import React from "react";
import { MessageCircle } from "lucide-react";
import { useSettings } from "../lib/settings-context";
import { buildWhatsAppUrl } from "../lib/whatsapp";
import { reportWhatsAppClick } from "../lib/whatsapp-beacon";

/**
 * Contextual "¿Dudas con tu pedido/envío?" contact card. Renders a green outline
 * WhatsApp button pre-filled with a Spanish message that includes the short id.
 */
export default function WhatsAppContextualLink({
  kind, // "pedido" | "envio"
  shortId,
  testId = "whatsapp-contextual-link",
}) {
  const { whatsappNumber, whatsappFloatingEnabled } = useSettings();
  // If admin turned WhatsApp off entirely, don't render contextual link either.
  if (!whatsappFloatingEnabled) return null;

  const label =
    kind === "envio"
      ? "¿Dudas con tu envío?"
      : "¿Dudas con tu pedido?";
  const prefill =
    kind === "envio"
      ? `Hola MercaGo, tengo una consulta sobre el envío ${shortId}`
      : `Hola MercaGo, tengo una consulta sobre el pedido ${shortId}`;
  const href = buildWhatsAppUrl(whatsappNumber, prefill);

  return (
    <section
      data-testid={`${testId}-section`}
      className="mt-6 rounded-2xl border border-emerald-200 bg-emerald-50/40 p-5"
    >
      <h3 className="text-sm font-black tracking-tight text-emerald-900">
        {label}
      </h3>
      <p className="text-sm text-emerald-900/80 mt-1 mb-3">
        Escríbenos por WhatsApp y te ayudamos en minutos.
      </p>
      <a
        data-testid={testId}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          reportWhatsAppClick(kind === "envio" ? "shipment_page" : "order_page")
        }
        className="inline-flex items-center gap-2 rounded-full border-2 border-[#25D366] text-[#0b6b2e] hover:bg-[#25D366] hover:text-white px-4 py-2 text-sm font-semibold transition-colors"
      >
        <MessageCircle className="h-4 w-4" />
        Contactar por WhatsApp
      </a>
    </section>
  );
}
